export default __webpack_public_path__ + "static/media/home_banner_3.dc70fd10.jpg";